import List from "@/components/list";
import vue from "@/main";
import router from "@/router";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};

  // 编辑试卷
  function editPaper({ uuid }) {
    router.push({ path: "/examPaper/edit", query: { id: uuid } });
  }

  // 删除试卷
  function deletePaper(paper) {
    vue.$emit("deleteExamPaper", paper);
  }

  // 预览试卷
  function previewPaper(paper) {
    vue.$emit("previewExamPaper", paper);
  }
  // 跳转试卷详情
  function goPaperDetail(item) {
    router.push({ path: "/examPaper/detail", query: { id: item.uuid } });
  }

  const Deal = ({ props: { vo } }) => {
    const paper = vo.row;
    const dealConf = [
      [
        paper.publishStatus === 0 ? "icon-edit" : "icon-edit-disable",
        "编辑",
        paper.publishStatus === 0
          ? () => {
              editPaper(paper);
            }
          : () => {},
        "examPaper:update"
      ],
      [
        paper.publishStatus === 0 ? "icon-delete" : "icon-delete-disable",
        "删除",
        paper.publishStatus === 0
          ? () => {
              deletePaper(paper);
            }
          : () => {},
        "examPaper:delete"
      ],
      [
        "icon-preview",
        "预览",
        () => {
          previewPaper(paper);
        },
        "examPaper:preview"
      ]
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const PaperName = ({ props: { vo } }) => {
    return (
      <div class="base-hover-char" onClick={() => goPaperDetail(vo.row)}>
        {vo.row.paperName}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "试卷名称",
      prop: "paperName",
      minWidth: "150",
      render: (vo) => <PaperName vo={vo} />,
    },
    {
      label: "试卷类型",
      prop: "paperTypeName",
      width: "120"
    },
    {
      label: "试题总数",
      prop: "totalNum",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "试卷总分",
      prop: "totalScore",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "发布状态",
      prop: "publishStatusName",
      width: "120",
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate",
      width: "180",
    },
    {
      label: "操作",
      fixed: "right",
      width: "150",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
